<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M2.2 12c0-1.3.3-2.6.7-3.8.5-1.1 1.2-2.2 2.2-3.1.9-.9 2-1.6 3.2-2.1s2.5-.7 3.8-.7 2.6.3 3.8.7c1.2.5 2.3 1.2 3.2 2.1.9.9 1.6 2 2.1 3.2.5 1.2.7 2.5.7 3.8 0 2.6-1 5.1-2.9 6.9-1.8 1.8-4.3 2.9-6.9 2.9-2.6 0-5.1-1-6.9-2.9-2-1.9-3-4.4-3-7zM12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm5.2 8.3c.1-.1.1-.2.2-.4v-.4c0-.1-.1-.3-.1-.4-.1-.1-.2-.3-.3-.3-.1-.1-.2-.1-.4-.2h-.4c-.1 0-.3.1-.4.1l-.3.3-5.8 7.7-2.4-2.4c-.2-.2-.5-.3-.8-.3-.3 0-.6.1-.8.3-.2.2-.3.5-.3.8 0 .3.1.6.3.8L9 17.1c.1.1.2.2.4.3.1.1.3.1.5.1s.3-.1.4-.1c.1-.1.3-.2.4-.3l6.5-8.8z"
    />
  </svg>
</template>
